import { Pagination } from "src/app/services/response-models/projects.response.model";

export class LoadUsersPagination {
    static readonly type = "[Users] Load pagination";

    constructor(public payload: Pagination) {}
}
